export default (() => {
  function toggleDownloadBrochure(e) {
      e.preventDefault();
      
      var wrapper = $('.download-brochure');
      var backdrop = $('#backdrop.download-brochure-control');

      if(wrapper.hasClass('open')) {
          wrapper.removeClass('open');
          backdrop.removeClass('active');
          return;
      }

      backdrop.addClass('active');
      wrapper.addClass('open');
  }

  $('a[href="#download-brochure"]').click(toggleDownloadBrochure);
  $('.download-brochure-control').click(toggleDownloadBrochure);
});



// WEBPACK FOOTER //
// ./scripts/components/download-brochure.js